<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    CTAs
                </div>
                <app-draggable :list="element.object.values.items" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.items.length > 0">
                    <app-collapseable-box
                        v-for="(item, index) in element.object.values.items"
                        class="draggable mb-4"
                        :key="index"
                        :index="index"
                        @remove="remove"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`CTA ${(index + 1)} `" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="remove(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <div>
                            <label class="text-xs">
                                Image
                            </label>
                            <app-field-file
                                class="mt-2"
                                v-model="element.object.values.items[index].image"
                                :types="{images: true, files: false}"
                            />
                        </div>

                        <app-field-text
                            label="Title"
                            v-model="element.object.values.items[index].title"
                        />

                        <app-field-text
                            label="Label"
                            v-model="element.object.values.items[index].label"
                        />

                        <app-field-text
                            label="Description"
                            v-model="element.object.values.items[index].description"
                        />

                        <app-field-text
                            label="URL"
                            v-model="element.object.values.items[index].url"
                        />
                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no cta blocks.
                </p>

                <div class="px-4 text-right w-full">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="add">
                        Add
                    </app-button>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';

    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import FileField from '@/components/fields/inputs/File';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import draggable from 'vuedraggable';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-text': TextField,
            'app-toggle-field': ToggleField,
            'app-field-file': FileField,
        },
        props: {
            element: {
                type: Object,
                required: true
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        methods: {
            add() {
                this.element.object.values.items.push({
                    'image': null,
                    'title': '',
                    'label': '',
                    'description': '',
                    'url': ''
                });
            },

            remove(index) {
                this.element.object.values.items.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/CtaBlocksSettings.vue